import { Injectable } from '@angular/core';
import { WizyDialogRef, WizyDialogService } from 'src/app/modules/shared/design-system/modal';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmationOptions } from './confirmationOptions.model';

@Injectable()
export class ConfirmationService {
    constructor(private dialog: WizyDialogService) {}

    confirm(input: string | ConfirmationOptions, callback: () => any, callbackCancel?: () => any): WizyDialogRef<any> {
        if (typeof input === 'string') {
            return this.doConfirm({ message: input }, callback, callbackCancel);
        }
        return this.doConfirm(input, callback, callbackCancel);
    }

    confirmWarn(input: string | ConfirmationOptions, callback: () => any, callbackCancel?: () => any): WizyDialogRef<any> {
        if (typeof input === 'string') {
            return this.doConfirm({ message: input, warn: true }, callback, callbackCancel);
        }
        return this.doConfirm({ ...input, warn: true }, callback, callbackCancel);
    }

    private doConfirm(options: ConfirmationOptions, callback: () => any, callbackCancel?: () => any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: options,
            width: '430px',
            maxWidth: '70vw',
        });
        dialogRef.afterClosed().subscribe((dialogResult) => {
            if (dialogResult === true && callback) {
                callback();
            } else if (dialogResult === false && callbackCancel) {
                callbackCancel();
            }
        });
        return dialogRef;
    }
}
